module.exports = __webpack_public_path__ + "static/img/icon_data.5909c867.svg";